import { Partial } from '@40seas/entities/common';
import { HeronReport } from './heron-report.entity';

export class UpdateHeronReportDto extends Partial(HeronReport) {}
